import { ModuleWithProviders, NgModule } from '@angular/core';

// TOOLS
import { ToolsModule } from './tools/tools.module';

// PIPES
import { PipesModule } from './pipes/pipes.module';

// DIRECTIVES
import { DirectivesModule } from './directives/directives.module';

// SERVICES
import { LoaderService } from './services/loader.service';
import { NotificationService } from './services/notification.service';


@NgModule({
    imports: [
        ToolsModule,
        PipesModule,
        DirectivesModule
    ],
    exports: [
        ToolsModule,
        PipesModule,
        DirectivesModule
    ]
})
export class ToolkitModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: ToolkitModule,
            providers: [NotificationService, LoaderService]
        };
    }
}
